import { useEffect, useState } from "react";
import { equalTo, onValue, orderByChild, query } from "firebase/database";
import { enquiriesDbRef } from "../utils/dbRefs";
import { useAuth } from "../contexts/AuthContext";

export const useEnquiriesCount = () => {
    const { currentUser } = useAuth();

    const [unreadCount, setUnreadCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [repliedCount, setRepliedCount] = useState(0);
    const [newEnquiriesCount, setNewEnquiriesCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!currentUser?.uid) return;

        setLoading(true);

        const enquiriesQuery = query(enquiriesDbRef, orderByChild("shopId"), equalTo(currentUser.uid));
        const unsubscribe = onValue(enquiriesQuery, (snapshot) => {
            const data = snapshot.val();

            if (!data) {
                setUnreadCount(0);
                setTotalCount(0);
                setRepliedCount(0);
                setLoading(false);
                return;
            }

            const myEnquiries = Object.values(data);

            const threeDaysAgo = Date.now() - 3 * 24 * 60 * 60 * 1000;

            const newEnquiries = myEnquiries.filter(
                (e) =>
                    e.createdAt >= threeDaysAgo &&
                    (!e.isRead || !e.isReplied)
            ).length;


            const unread = myEnquiries.filter((e) => !e.isRead).length;

            const replied = myEnquiries.filter(
                (e) => e.isReplied === true
            ).length;

            setUnreadCount(unread);
            setTotalCount(myEnquiries.length);
            setRepliedCount(replied);
            setNewEnquiriesCount(newEnquiries);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [currentUser?.uid]);

    return {
        unreadEnquiriesCount: unreadCount,
        totalEnquiriesCount: totalCount,
        repliedEnquiriesCount: repliedCount,
        newEnquiriesCount,
        loading,
    };
};
